import React from "react";
import { useLocation } from "react-router-dom";
import "./AccessDenied.scss";

import { usePageTitle } from "../title-management/usePageTitle";
import IDHFormattedMessage from "../components/IDHFormattedMessage/IDHFormattedMessage";

export function AccessDenied() {
  usePageTitle("Access denied");

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const entries = Array.from(params.entries());

  return (
    <div className="access_denied">
      <div className="access_denied__text">
        <IDHFormattedMessage
          id="ws_access_denied_description"
          defaultMessage="You don’t have access to this resource."
        />
      </div>

      {entries.length > 0 && (
        <div className="access_denied__debug">
          {entries.map(([key, value]) => (
            <span key={key}>
              {key}:{value},&nbsp;
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
